module.exports = __webpack_public_path__ + "img/free-code-camp-brands.1ac9af7b.svg";